export default {
  title: "Saldo",
  descriptionDefault: "Tieni traccia di guadagni e movimenti",
  descriptionFull: "Tieni traccia di tutti i movimenti delle tue attività",
  hostIdMissing: "ID utente host non trovato",
  salesAgentIdMissing: "ID utente agente di commercio non trovato",
  sellerIdMissing: "ID utente venditore non trovato",
  loadingBalance: "Caricamento dati saldo...",
  errorLoad: "Errore nel caricamento dei dati del portafoglio",
  statCurrentBalance: "Saldo attuale",
  statAmountOwed: "Importo dovuto",
  statTotalIncome: "Entrate totali (periodo)",
  statTotalExpenses: "Uscite totali (periodo)",
  statTransactions: "Movimenti (periodo)",
  filtersTitle: "Filtri di ricerca",
  filtersActive_one: "{{count}} filtro attivo",
  filtersActive_other: "{{count}} filtri attivi",
  filtersHint: "Imposta i filtri per restringere i risultati",
  dateRange: "Intervallo date",
  from: "Da",
  to: "A",
  searchCriteria: "Criteri di ricerca",
  searchDescriptionLabel: "Cerca nella descrizione",
  searchDescriptionPlaceholder: "Cerca movimenti...",
  activityLabel: "Attività",
  allActivities: "Tutte le attività",
  amountRange: "Intervallo importo",
  minAmount: "Importo minimo (€)",
  maxAmount: "Importo massimo (€)",
  placeholderMin: "0,00",
  placeholderMax: "Nessun limite",
  clearFilters: "Cancella tutti i filtri",
  applyFilters: "Applica nuovi filtri",
  searchTransactions: "Cerca movimenti",
  unsavedFilters:
    "Hai modifiche ai filtri non applicate. Clicca «Applica nuovi filtri» per cercare.",
  transactionsTitle: "Movimenti",
  results_one: "{{count}} risultato",
  results_other: "{{count}} risultati",
  loadingTransactions: "Caricamento movimenti...",
  emptyTitle: "Nessun movimento trovato",
  emptyDescFiltered: "Prova ad aggiustare i filtri",
  emptyDescDefault: "I tuoi movimenti appariranno qui",
} as const;
